import * as React from 'react';
import { createContext, useContext } from 'react';

import { isAuthenticatedUser } from 'js/lib/user';

import { CoachStateProvider } from 'bundles/unified-common/providers/CoachStateProvider';
import { useTwoPanelConversationalDiscoveryExperiment } from 'bundles/unified-description-page-common/providers/specialization/TwoPanelConversationalDiscoveryExperimentProvider';

export type CoachCareerFitAssistantContextType = {
  coachCareerFitAssistantEnabled: boolean;
};

export const CoachCareerFitAssistantContext = createContext<CoachCareerFitAssistantContextType>({
  coachCareerFitAssistantEnabled: false,
});

function CoachCareerFitAssistantProvider({ children }: React.PropsWithChildren) {
  const isAuthenticated = isAuthenticatedUser();
  const { twoPanelConversationalDiscoveryEnabled } = useTwoPanelConversationalDiscoveryExperiment();

  const coachCareerFitAssistantEnabled = isAuthenticated && !twoPanelConversationalDiscoveryEnabled;

  return (
    <CoachCareerFitAssistantContext.Provider
      value={{
        coachCareerFitAssistantEnabled,
      }}
    >
      {coachCareerFitAssistantEnabled ? <CoachStateProvider>{children}</CoachStateProvider> : children}
    </CoachCareerFitAssistantContext.Provider>
  );
}

export const useCoachCareerFitAssistantData = () => {
  return useContext(CoachCareerFitAssistantContext);
};

export default CoachCareerFitAssistantProvider;
